import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import ExportModalTables from "../../components/ExportModalTables";
import PortalPopup from "../../components/PortalPopup";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import NavigationPanelLawyer from "../../components/NavigationPanelLawyer";
import CTAs from "../../components/CTAs";
import Footer from "../../components/Footer";

const CDI_2 = () => {
  const navigate = useNavigate();
  const [isExportModalTablesOpen, setExportModalTablesOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const onClickClientInstruction = useCallback(() => {
    navigate("/cdi1");
  }, [navigate]);

  const openExportModalTables = useCallback(() => {
    setExportModalTablesOpen(true);
  }, []);

  const closeExportModalTables = useCallback(() => {
    setExportModalTablesOpen(false);
  }, []);

  const onSeeDetailsTextClick = useCallback(() => {
    navigate("/cdi4");
  }, [navigate]);

  const onDebtCollectionNavContainer3Click = useCallback(() => {
    // Add your code here
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const navItems = [
    {
      text: "Dashboard",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/dashboard",
    },
    {
      text: "Legal proceedings & billing",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/legal_1",
    },
    {
      text: "Pre-LBA checks",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/prelbacheck",
    },
    {
      text: "Client-debtor interaction",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
    },
  ];

  // For table
  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const defence_list = [
    {
      date: "01/02/2025",
      status: "Resolved",
      defence: "Denial of debt",
      action: "See details",
    },
    {
      date: "01/02/2025",
      status: "Resolved",
      defence: "Dispute over amount",
      action: "See details",
    },
    {
      date: "01/02/2025",
      status: "Pending",
      defence: "Payment disbutes",
      action: "See details",
    },
    {
      date: "01/02/2025",
      status: "Resolved",
      defence: "Lack of proper notice",
      action: "See details",
    },
    {
      date: "01/02/2025",
      status: "Negotiating",
      defence: "Statue of limitations",
      action: "See details",
    },
    {
      date: "01/02/2025",
      status: "Responded",
      defence: "Disputes over contract terms",
      action: "See details",
    },
    {
      date: "01/02/2025",
      status: "Pending",
      defence: "Identity Theft or Fraud",
      action: "See details",
    },
    {
      date: "01/02/2025",
      status: "Negotiating",
      defence: "Financial hardship",
      action: "See details",
    },
    {
      date: "01/02/2025",
      status: "Resolved",
      defence: "Unfair practices",
      action: "See details",
    },
    {
      date: "01/02/2025",
      status: "Responded",
      defence: "Counter claims",
      action: "See details",
    },
  ];

  const filteredDefences =
    activeTab === "all"
      ? defence_list
      : defence_list.filter(
          (debtor) => debtor.status.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedDefence = filteredDefences.filter(
    (debtor) =>
      debtor.date.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.defence.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.action.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const statusColorMap = {
    Negotiating: "bg-red-100 text-red-500 border-red-500",
    Pending: "bg-yellow-100 text-yellow-600 border-yellow-500",
    Resolved: "bg-green-100 text-green-500 border-green-500",
    Responded: "bg-blue-100 text-blue-500 border-blue-500",
  };

  const statusIconMap = {
    Negotiating: "•",
    Pending: "•",
    Resolved: "•",
    Responded: "•",
  };

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 h-[1233px] overflow-hidden text-left text-base text-neutrals-neutral-300 font-open-sans-ff-body-strong">
        {/* Navigation Panel */}
        <NavigationPanelLawyer navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 text-neutrals-neutral-900 px-4 md:px-4 lg:px-24 pb-16 box-border">
          <div className="self-stretch flex flex-col items-start justify-start gap-1">
            <b className="self-stretch relative text-9xl">
              Client-debtor interaction
            </b>
            <div className="self-stretch relative text-base text-neutrals-neutral-300">{`Get all your information for client & debtor over here.`}</div>
          </div>
          <div className="self-stretch flex flex-col items-start justify-start gap-6 text-base text-neutrals-neutral-300">
            <div className="flex flex-row items-start justify-start gap-6">
              <div
                className="bg-bg-primary h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
                onClick={onClickClientInstruction}
              >
                <div className="flex flex-row items-center justify-center">
                  <div className="relative font-semibold">
                    Client instructions
                  </div>
                </div>
              </div>
              <div className="bg-bg-primary border-primary-primary-500 border-solid border-b-[2px] box-border h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 text-primary-primary-500">
                <div className="flex flex-row items-center justify-center">
                  <div className="relative font-semibold">
                    Handling defences
                  </div>
                </div>
              </div>
            </div>
            <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] flex flex-col items-start justify-start text-sm text-neutrals-neutral-900">
              <div className="w-full rounded-t-3xs rounded-b-none border-neutrals-neutral-100 border-solid border-t-[1px] border-r-[1px] border-l-[1px] box-border flex flex-row items-center justify-between py-5 px-6 gap-0 text-lg">
                <div className="flex flex-row items-center justify-start gap-2.5">
                  <div className="relative font-semibold">Defence list</div>
                  <div className="rounded-[5px] bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-start py-0.5 px-2 gap-1.5 text-sm">
                    <div className="w-1.5 relative rounded-[50%] bg-primary-primary-500 h-1.5" />
                    <div className="relative font-semibold">10 entries</div>
                  </div>
                </div>
                <CTAs
                  type="Secondarybtn"
                  text="Export"
                  borderColor="border-neutrals-neutral-100"
                  position="relative"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        stroke="#2d404e"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M16.44 8.9c3.6.31 5.07 2.16 5.07 6.21v.13c0 4.47-1.79 6.26-6.26 6.26H8.74c-4.47 0-6.26-1.79-6.26-6.26v-.13c0-4.02 1.45-5.87 4.99-6.2M12 15V3.62M15.35 5.85L12 2.5 8.65 5.85"
                      ></path>
                    </svg>
                  }
                  onClick={openExportModalTables}
                />
              </div>
              <div className="w-full border-neutrals-neutral-100 border-solid border-t-[1px] border-r-[1px] border-l-[1px] box-border flex flex-row items-center justify-between py-3 px-6 gap-0">
                <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-start">
                  <div className="rounded-tl-3xs rounded-tr-none rounded-br-none rounded-bl-3xs bg-column-bg border-neutrals-neutral-100 border-solid border-r-[1px] flex flex-row items-center justify-center py-2 px-4">
                    <div className="relative font-semibold">View all</div>
                  </div>
                  <div className="border-neutrals-neutral-100 border-solid border-r-[1px] flex flex-row items-center justify-center py-2 px-4">
                    <div className="relative font-semibold">Resolved</div>
                  </div>
                  <div className="border-neutrals-neutral-100 border-solid border-r-[1px] flex flex-row items-center justify-center py-2 px-4">
                    <div className="relative font-semibold">Pending</div>
                  </div>
                  <div className="border-neutrals-neutral-100 border-solid border-r-[1px] flex flex-row items-center justify-center py-2 px-4">
                    <div className="relative font-semibold">Negotiating</div>
                  </div>
                  <div className="rounded-tl-none rounded-tr-3xs rounded-br-3xs rounded-bl-none flex flex-row items-center justify-center py-2 px-4">
                    <div className="relative font-semibold">Responded</div>
                  </div>
                </div>
                <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-row items-center justify-start py-2.5 px-3.5 text-neutrals-neutral-300">
                  <div className="flex flex-row items-center justify-start gap-2.5">
                    <img
                      className="w-5 relative h-5"
                      alt=""
                      src="assets/search.svg"
                    />
                    <div className="relative">Search</div>
                  </div>
                </div>
              </div>
              <div className="w-full flex flex-col items-start justify-start">
                <div className="w-full flex flex-col items-start justify-start">
                  <div className="self-stretch flex flex-row items-start justify-start">
                    <table className="min-w-full divide-y divide-gray-200 border-collapse">
                      <thead className="bg-column-bg">
                        <tr>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Date
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Status
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Nature of defence
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-r-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-neutrals-neutral-50 divide-y divide-gray-200">
                        {searchedDefence.map((defence_list) => (
                          <tr key={defence_list.id} className="hover:bg-gray">
                            <td className="p-4 items-start border-solid border-b-[1px] border-l-[1px] border-neutrals-neutral-100">
                              {defence_list.date}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100 whitespace-nowrap">
                              <span
                                className={`px-2 py-0.5 text-xs font-semibold rounded-full border-solid border-[1px] ${
                                  statusColorMap[defence_list.status]
                                }`}
                              >
                                <span className="mr-1">
                                  {statusIconMap[defence_list.status]}
                                </span>
                                {defence_list.status}
                              </span>
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                              {defence_list.defence}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-r-[1px] border-neutrals-neutral-100">
                              {defence_list.action}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* Pagination */}
              <div className="w-full rounded-t-none rounded-b-3xs bg-neutrals-neutral-50 box-border flex flex-row items-center justify-between pt-3 px-6 pb-4 border-r-[1px] border-solid border-neutrals-neutral-100 border-b-[1px] border-l-[1px]">
                <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                  <div className="flex flex-row items-center justify-center">
                    <div className="relative font-semibold">Previous</div>
                  </div>
                </div>
                <div className="relative">Page 1 of 10</div>
                <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-center py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                  <div className="flex flex-row items-center justify-center">
                    <div className="relative font-semibold">Next</div>
                  </div>
                </div>
              </div>
              {/* Footer */}
              <Footer />
            </div>
          </div>
        </div>
      </div>
      {isExportModalTablesOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeExportModalTables}
        >
          <ExportModalTables onClose={closeExportModalTables} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default CDI_2;
